import { APPLICATION_STATUSES } from "@/constants/applications";
import { SORTED_APPLICATION_STATUSES } from "@/constants/applications";
import { get, find, reduce, sortBy, upperCase, every, first } from "lodash";

export const getApplicationStatusInfo = status =>
  APPLICATION_STATUSES[upperCase(status)] || {
    title: status,
    color: "gray"
  };

export const getApplicationStatusColor = ({ status }) =>
  getApplicationStatusInfo(status).color;

export const getApplicationStatusTitle = ({ status }) =>
  getApplicationStatusInfo(status).title;

const groupByEvaluationAndApplicationStatus = applications => {
  const sortedApplications = sortBy(applications, "user.lastName");
  return reduce(
    sortedApplications,
    (grouped, application) => {
      const propertyName =
        application.status === "evaluated" ? "evaluationStatus" : "status";
      const applicationPropertyName =
        application[propertyName] == "shortlisted"
          ? "released applications"
          : application[propertyName];
      const groupedByProperty = grouped[applicationPropertyName];
      if (!groupedByProperty) {
        grouped[applicationPropertyName] = [application];
      } else {
        grouped[applicationPropertyName] = [...groupedByProperty, application];
      }
      return grouped;
    },
    {}
  );
};

export const areBothStatusesEvaluated = ({ statusEntriesToCompare }) => {
  return every(
    statusEntriesToCompare,
    statusEntry => first(statusEntry[1]).status === "evaluated"
  );
};

export const sortByApplicationStatus = (
  groupedApplicationsObj,
  evaluationStatuses
) => {
  return Object.entries(groupedApplicationsObj)
    .sort((a, b) => {
      if (areBothStatusesEvaluated({ statusEntriesToCompare: [a, b] })) {
        // compare evaluation statuses by display order
        return (
          getDisplayOrder(a[0], evaluationStatuses) -
          getDisplayOrder(b[0], evaluationStatuses)
        );
      }
      // compare by application status
      return (
        SORTED_APPLICATION_STATUSES.indexOf(first(a[1]).status) -
        SORTED_APPLICATION_STATUSES.indexOf(first(b[1]).status)
      );
    })
    .reduce((sortedObj, item) => {
      sortedObj[item[0]] = item[1];
      return sortedObj;
    }, {});
};

export const getGroupedAndSortedApplications = (
  applications,
  evaluationStatuses
) => {
  return sortByApplicationStatus(
    groupByEvaluationAndApplicationStatus(applications),
    evaluationStatuses
  );
};

const getDisplayOrder = (statusName, evaluationStatuses) => {
  return get(find(evaluationStatuses, { name: statusName }), "displayOrder");
};
